import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=20e68c6e&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./Communication.vue?vue&type=style&index=0&id=20e68c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e68c6e",
  null
  
)

export default component.exports